import _ from "@lodash";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import EmpresaPessoaApp from "../EmpresaPessoaApp";
import * as Actions from "../Store/Actions/EmpresaPessoaActions";

const EmpresaPessoaToggleButton = (props) => {

    const { get, idpessoaformulario, xappRouteParams, iconProps = null, children = null, callback } = props;

    return (
        <React.Fragment>
            {idpessoaformulario &&
                <EmpresaPessoaApp
                    id="EmpresaPessoaBtn"
                    isButton={true}
                    callback={callback}
                />
            }
            {idpessoaformulario &&
                <React.Fragment>
                    {!_.isNull(children) ?
                        <div
                            onClick={(ev) => {

                                get(idpessoaformulario, xappRouteParams);
                                ev.stopPropagation();
                            }}
                        >
                            {children}
                        </div>
                        :
                        <XAPPButton
                            tooltip={{ "title": "Editar", "placement": "top" }}
                            type="icon"
                            className="p-8"
                            variant="contained"
                            color="textSecondary"
                            onClick={(ev) => { get(idpessoaformulario, xappRouteParams); ev.stopPropagation(); }}
                            iconProps={iconProps !== null ? iconProps : "text-18 text-white"}
                            icon={"edit"}
                        />
                    }
                </React.Fragment>
            }
        </React.Fragment>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        get: Actions.get
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(EmpresaPessoaToggleButton);
